export default {
  computed: {
    metaTitle() {
      return this.$route?.meta?.title || ''
    },
  },
}
